import Container from "../Container";
import SectionHeader from "../SectionHeader";
import FeatureCard from "./components/FeatureCard";
import {
  aiAgentImg,
  frameImg,
  socialFiImg,
  webImg,
  infoFiImg,
  xMiniAppsImg,
  socialFiNewImg,
  agntXAppStudioImg,
} from "../../../../assets/landing/features";
import { useEffect, useRef } from "react";
import { useAnimation, useInView, motion } from "framer-motion";
import clsx from "clsx";

const analyticsWeb3 = [
  "Social + onchain data on protocols, chains, launchpads and VCs",

  "Mindshare and token insights in-feed",

  "Chain distribution and investor mapping across protocols",
];

const frames = [
  "Native apps that run directly inside X",
  "Desktop in the X surface, mobile via AGNT Mobile",
  "Progress remembered, actions continued",
];

const socials = [
  "Attention-to-earn tasks embedded directly into the feed",
  "Rewards tied to real onchain actions, not vanity metrics",
  "Campaigns to engage and retain high-intent users",
];

const infos = [
  "Zero-code studio for protocols to launch native X Mini Apps",
  "Ready-made components for launches and flows",
  "Retention mechanics baked into the same environment",
];

const aiAgents = [
  "Protocol-specific modules embedded on X pages",
  "Chat-based UX for dApp actions, alpha, and support",
  "Simplified engagement and execution UX for protocols",
];

const Features = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  // Parent container for stagger
  const containerVariants = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3, // Adjust the delay as needed
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <div ref={ref}>
      <Container
        animationControls={controls}
        sectionClasses="mt-[9.71vw] max-lg:mt-[20vw] relative overflow-y-hidden max-lg:overflow-hidden max-lg:pb-[27vw] pb-[9vw]"
      >
        <motion.div>
          <SectionHeader
            sectionHeaderClasses="mb-[1.714vw] max-lg:mb-[6.4vw]"
            title="Features"
            desc="What AGNT is About"
          />
        </motion.div>

        <motion.div
          className="grid grid-cols-2 max-lg:grid-cols-1 max-lg:gap-[6.4vw] gap-[1.714vw] mb-[1.714vw] max-lg:mb-[6.4vw]"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {[
            {
              title: "Web3 Analytics",
              analytics: analyticsWeb3,
              image: webImg,
              classes: "w-full overflow-hidden group relative",
            },
            {
              title: "X Mini Apps",
              analytics: frames,
              image: xMiniAppsImg,
              classes: "w-full overflow-hidden",
              imageClasses:
                "absolute bottom-0 lg:left-1/2 max-lg:-bottom-[4vw] lg:-translate-x-1/2 max-lg:w-[160vw] max-lg:left-[6vw] w-[42vw]",
            },
          ].map(({ title, analytics, image, classes, imageClasses }, index) => (
            <motion.div key={index} variants={cardVariants}>
              <FeatureCard
                title={title}
                cardClasses={classes}
                analytics={analytics}
              >
                <div
                  className={clsx(
                    imageClasses ||
                      "absolute bottom-6 left-7 max-lg:left-[4vw] w-[180vw] md:w-[181.5vw] md:left-0 md:w-[190vw] lg:w-[49.428vw]"
                  )}
                >
                  <img
                    src={image}
                    alt="feature image"
                    className={`w-full ${
                      index !== 0 && "max-lg:ml-[5vw]"
                    } h-auto`}
                  />
                </div>
              </FeatureCard>
            </motion.div>
          ))}
        </motion.div>

        {/* Second Row */}
        <motion.div
          className="grid grid-cols-2 max-lg:grid-cols-1 max-lg:gap-[6.4vw] gap-[1.714vw] mb-[1.714vw] max-lg:mb-[6.4vw]"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {[
            {
              title: "SocialFi & InfoFi Campaigns",
              analytics: socials,
              image: socialFiNewImg,
              classes: "w-full overflow-hidden",
              imageClasses:
                "absolute bottom-0 lg:left-1/2 max-lg:-bottom-[4vw] lg:-translate-x-1/2 max-lg:w-[160vw] max-lg:left-[6vw] w-[42vw]",
            },
            {
              title: "AGNT X App Studio",
              analytics: infos,
              image: agntXAppStudioImg,
              classes: "w-full overflow-hidden",
              imageClasses:
                "absolute bottom-0 lg:left-1/2 max-lg:-bottom-[4vw] lg:-translate-x-1/2 max-lg:w-[160vw] max-lg:left-[6vw] w-[42vw]",
            },
          ].map(({ title, analytics, image, classes, imageClasses }, index) => (
            <motion.div key={index} variants={cardVariants}>
              <FeatureCard
                title={title}
                cardClasses={classes}
                analytics={analytics}
              >
                <div
                  className={clsx(
                    imageClasses ||
                      "absolute bottom-6 left-7 max-lg:left-[1vw] w-[180vw] md:w-[181.5vw] md:left-0 md:w-[190vw] lg:w-[49.428vw]"
                  )}
                >
                  <img
                    src={image}
                    alt="feature image"
                    className="w-full max-lg:ml-[4.2vw] h-auto"
                  />
                </div>
              </FeatureCard>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </div>
  );
};

export default Features;
